module.exports = __webpack_public_path__ + "static/media/completed-punch.32213737.png";